import React from 'react';
import { Menu } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';

import { history } from "../../../helpers";
import { UserNav } from "./UserNav";
import ToolbarDesigner from "./Toolbar/Designer";
import ToolbarInitiative from './Toolbar/Initiative';
import ToolbarContent from './Toolbar/Content';
import ToolbarOrganization from './Toolbar/Organization';
import ToolbarHome from './Toolbar/ToolbarHome';
import ToolbarActivities from './Toolbar/ToolbarActivities';
import ToolbarAccountHome from './Toolbar/ToolbarAccountHome';
import ToolbarAccountUsers from './Toolbar/ToolbarAccountUsers';
import { OrgSelector } from "./OrgSelector";
import AccountSelector from "./AccountSelector";
import TimeZone from './TimeZone'
import Notifications from "./Notifications";
import AccountSelectionModal from '../Modal/AccountSelectionModal';
import DeactivatedAccountInfoModal from '../Modal/DeactivatedAccountInfoModal';
import { Modal, Divider, Button } from 'semantic-ui-react';

import CategorySetting from './Toolbar/account/Category';
import TagSetting from './Toolbar/account/Tag';
import ToolbarAccountBilling from './Toolbar/ToolbarAccountBilling';
import defaultLogo from './../../../images/logo/logo-80x50.png';
import ToolbarTemplateDesigner from './Toolbar/ToolbarTemplateDesigner';
import ToolbarDashboardDesigner from './Toolbar/ToolbarDashboardDesigner'
import ToolbarPlatformUsers from './Toolbar/ToolbarPlatformUsers';
import ToolbarPlatformAccounts from './Toolbar/ToolbarPlatformAccounts';
import ToolbarPlatformDashboard from './Toolbar/ToolbarPlatformDashboard';
import ToolbarCustomTemplate from './Toolbar/Workspace/ToolbarCustomTemplate'

import IntegrationSetting from './Toolbar/Platform/Integration';
import DeactivatedWorkspaceModal from '../Modal/DeactivatedWorkspaceModal';
import SubscriptionLimitErrorModal from '../Modal/SubscriptionLimitErrorModal';
import ActiveGenerationBlockedModal from '../Modal/ActiveGenerationBlockedModal';
import TopUpFreeCreditsModal from '../Modal/TopUpFreeCreditsModal';

class AppHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isNotificationVisible: false,
            isInboxVisible: false
        };
    }

    async componentDidMount() {
        await dispatch.lifeCycle.activePage(null);
        await dispatch.notifications.accountNotificationsCount({ accountId: this.props.selectedAccount._id, organizationId: this.props.selectedOrganisation.id })
        await dispatch.organizationTab.getCurrentOrganizationData(this.props.selectedOrganisation.id)

    }

    logoClick = (open) => {
        if (this.props.user.accounts && this.props.user.accounts.length === 1) {
            history.push({
                pathname: '/app/' + this.props.selectedAccount._id + '/dashboard'
            });
        }
        else {
            dispatch.account.setViewAccountFlag(true);
        }
    }

    closeIsActiveModal = () => {
        history.push(`/app/${this.props.selectedAccount._id}/dashboard`);
        dispatch.app.setIsActiveModal(false);
    }

    logout = () => {
        dispatch.login.logout();
    };

    goToHome = async () => {
        let path = ''

        if (this.props.selectedAccount.isPlatformAccount) {
            path = '/app/platform/home'
        }
        else if(this.props.organizations && this.props.organizations.length >0 && this.props.organizations.find(org => org.default) ){
            const defaultOrg = this.props.organizations.find(org => org.default);
            await dispatch.app.setSelectedOrganisationData(defaultOrg);
            if(defaultOrg.role === 'Member'){
               path = '/app/' + this.props.selectedAccount._id + '/_ws/' + defaultOrg.id + '/_at/myactivities'
            }
            path = '/app/' + this.props.selectedAccount._id + '/_ws/' + defaultOrg.id + '/_pb'
        } 
        else {
            path = '/app/' + this.props.selectedAccount._id + '/dashboard'
        }
        history.push({
            pathname: path
        });
    }

    setSelectedOrganization = async (org) => {
        await dispatch.app.setSelectedOrganisationData(org);
    }

    handleModalClose = () => {
        dispatch.app.setIsActiveModal(false);
        history.push(`/app/${this.props.selectedAccount._id}/dashboard`);
    }

    render() {
        const {
            user,
            organizations,
            context,
            handleInboxVisibleChange,
            handleNotificationChange,
            allNotification,
            selectedOrganisation,
            accountLogoObjectCloudinary,
            selectedAccount,
            baseModuleType,
            currentContext,
            allAccounts,
            handleStorageVisibleChange,
            notificationsCount,
            mainAreaContext,
            deActivateAccountModal,
            isActiveModal
        } = this.props

        const userRoleArray = user.accounts.filter(function (userAccount) {
            return (userAccount.id === selectedAccount._id);
        });
        let isAccountDeactivated = false;
        if (userRoleArray && userRoleArray.length > 0 && userRoleArray[0].role === 'customerAdmin' && userRoleArray[0].isActive === false) {
            isAccountDeactivated = true;
        }


        let orgSelector = <div className="display-contents" >
            <AccountSelector history={history} {...this.props} />
            {baseModuleType === "Workspace" ?
                <OrgSelector {...this.props} setOrganization={this.setSelectedOrganization} history={history} accountId={selectedAccount._id} /> :
                null}
            {baseModuleType === "Workspace" && selectedOrganisation ?
                <TimeZone selectedOrganisation={selectedOrganisation} /> :
                null}
        </div>


        //Toolbar-------------------------------------------------
        let Toolbar = baseModuleType === "Workspace" && currentContext === "designer" ?
            <ToolbarDesigner history={history} {...this.props} accountId={selectedAccount._id} /> :
            baseModuleType === "Workspace" && currentContext === "initiative" ?
                <ToolbarInitiative history={history}{...this.props} /> :
                baseModuleType === "Workspace" && currentContext === "content" ?
                    <ToolbarContent history={history}{...this.props} /> :
                    baseModuleType === "Workspace" && currentContext === "organization" ?
                        <ToolbarOrganization history={history}{...this.props} /> :
                        baseModuleType === "Workspace" && currentContext === "home" ?
                            <ToolbarHome history={history} /> :
                            baseModuleType === "Workspace" && currentContext === "activities" ?
                                <ToolbarActivities history={history} /> :
                                baseModuleType === "Account" && currentContext === "acc-home" ?
                                    <ToolbarAccountHome history={history}  {...this.props} /> :
                                    baseModuleType === "Account" && currentContext === "acc-user" ?
                                        <ToolbarAccountUsers history={history}  {...this.props} /> :
                                        ((currentContext === "acc-kb-setting" || currentContext === "ws-kb-setting" || currentContext === "pf-kb-setting") || (mainAreaContext === "baseCategory" || mainAreaContext === "category" || mainAreaContext === "subCategory" || mainAreaContext === "knowledgeBank") && currentContext != "wscustomtemplate") ?
                                            <CategorySetting history={history}  {...this.props} /> :
                                            baseModuleType === "Platform" && currentContext === "pf-Integration-setting" ?
                                                <IntegrationSetting history={history}  {...this.props} /> :
                                                baseModuleType === "Account" && currentContext === "acc-kb-setting" && mainAreaContext === "tags" ?
                                                    <TagSetting history={history}  {...this.props} /> :
                                                    baseModuleType === "Account" && currentContext === "acc-billing" ?
                                                        <ToolbarAccountBilling history={history}  {...this.props} /> :
                                                        baseModuleType === "Workspace" && currentContext === "template" ?
                                                            <ToolbarTemplateDesigner history={history}  {...this.props} /> :
                                                            baseModuleType === "Workspace" && currentContext === "dashboard" ?
                                                                <ToolbarDashboardDesigner history={history}  {...this.props} /> :
                                                                baseModuleType === "Platform" && currentContext === "platform-user" ?
                                                                    <ToolbarPlatformUsers history={history}  {...this.props} /> :
                                                                    baseModuleType === "Platform" && currentContext === "platform-account" ?
                                                                        <ToolbarPlatformAccounts history={history}  {...this.props} /> :
                                                                        baseModuleType === "Platform" && currentContext === "platform-dashboard" ?
                                                                            <ToolbarPlatformDashboard history={history}  {...this.props} /> :
                                                                            baseModuleType === "Workspace" && currentContext === "wscustomtemplate" ?
                                                                                <ToolbarCustomTemplate history={history}  {...this.props} /> :
                                                                                ""

        //Logo----------------------------------------------

        let logo = selectedAccount.isPlatformAccount ?
            <img className="logo fitLogoImage" src={defaultLogo} alt="Account Logo" /> :
            <img className="logo fitLogoImage" src={accountLogoObjectCloudinary && accountLogoObjectCloudinary.secure_url ?
                accountLogoObjectCloudinary.secure_url :
                selectedAccount.logo ? selectedAccount.logo : defaultLogo} alt="Account Logo" />

        return (
            <div style={{ boxShadow: "#000001 0 0 10px -6px", zIndex: "99" }}>
                <Menu attached='top' style={{ height: "50px", borderRadius: "0", border: "none", margin: "0" }}>
                    <Menu.Item
                        onClick={() => this.goToHome(true)}
                        name="Redirect to default workspace"
                        onMouseEnter={() => dispatch.app.setHelpContext("Account Logo")}
                        className="dd-hover"
                        style={{ textAlign: "center", width: "80px", padding: '0' }} >
                        {logo}
                    </Menu.Item>
                    <React.Fragment >
                        {orgSelector}
                    </React.Fragment>
                    <React.Fragment >
                        {Toolbar}
                    </React.Fragment>
                    <Menu.Menu position='right'  >
                        <Notifications
                            context={context}
                            allNotification={allNotification}
                            handleNotificationChange={handleNotificationChange}
                            handleInboxVisibleChange={handleInboxVisibleChange}
                            handleStorageVisibleChange={handleStorageVisibleChange}
                            notificationsCount={notificationsCount}
                            isAccountDeactivated={isAccountDeactivated}
                        />
                        <UserNav
                            user={user}
                            organizations={organizations}
                            onLogout={this.logout}
                            context={context}
                            selectedOrganisation={selectedOrganisation}
                            selectedAccount={selectedAccount}
                        />
                    </Menu.Menu>
                </Menu>
                <AccountSelectionModal
                    open={this.props.openViewAccountFlag}
                    user={user}
                    history={this.props.history}
                    allAccounts={allAccounts}
                    selectedAccount={this.props.selectedAccount}
                />
                <SubscriptionLimitErrorModal
                    subscriptionLimitError={this.props.subscriptionLimitError}
                    subscriptionLimitProps={this.props.subscriptionLimitProps}
                    accountId={this.props.selectedAccount._id}
                    user={user}
                    history={this.props.history}
                />
                <ActiveGenerationBlockedModal
                    activeGenerationBlockedModal={this.props.activeGenerationBlockedModal}
                    activeGenerationBlockedProps={this.props.activeGenerationBlockedProps}
                />
                <TopUpFreeCreditsModal
                    topUpCreditsModal={this.props.topUpCreditsModal}
                    topUpCreditsProps={this.props.topUpCreditsProps}
                    accountId={this.props.selectedAccount._id}
                    user={user}
                    history={this.props.history}
                />
                <DeactivatedAccountInfoModal
                    deActivateAccountModal={deActivateAccountModal}
                    user={user}
                    selectedAccount={selectedAccount}
                    logoClick={this.logoClick}
                />

                <DeactivatedWorkspaceModal
                    isActiveModal={isActiveModal}
                    user={user}
                    closeIsActiveModal={this.closeIsActiveModal}
                />
            </div >
        )
    }

}


function mapStateToProps(state) {

    const { user, currentContext, selectedOrganisation, selectedAccount, organizations, baseModuleType, accountSubscriptionDetail, isDefaultAccountSelected, showToolbarFlag,isActiveModal } = state.app;
    const { allNotification } = state.notifications;
    const { showResourecePaneFlag, enableLinkActivity, selectedPracticeLibrary, arrangementPaneActiveButtonFlag, enableDependencyIcon, playbookToExport, isPlaybookImported, packCount } = state.lifeCycle;
    const { activeStatus, activeTab, initiativeId, selectedDataById, intitiativeCountData } = state.initiatives;
    const { selectedSubOrg, isAllowedToAddOrgFlag, isDeleteDisabled, organizationCountData } = state.organizationUnit;
    const { mainAreaContext } = state.community;
    const { setAccountName, accountData, accountLogoObjectCloudinary } = state.registerAccount;
    const { allAccounts, selectedCategory, deActivateAccountModal, categoriesToExport } = state.account;
    const { contentCountData } = state.content;
    const { addedAccountUser } = state.invite;
    return {
        isActiveModal,
        user,
        organizations,
        currentContext,
        selectedOrganisation,
        allNotification,
        notificationsCount: state.notifications.notificationsCount,
        showResourecePaneFlag,
        enableLinkActivity,
        selectedPracticeLibrary,
        arrangementPaneActiveButtonFlag,
        enableDependencyIcon,
        playbookToExport,
        categoriesToExport,
        activeStatus,
        activeTab,
        initiativeId,
        selectedDataById,
        contentsToExport: state.content.contentsToExport,
        isPlaybookImported,
        isContentImported: state.content.isContentImported,
        isCopyActivityModalOpen: state.initiatives.isCopyActivityModalOpen,
        duplicateIconFlag: state.createPack.duplicateIconFlag,
        selectedPracticeFlowActivity: state.createPack.selectedPracticeFlowActivity,
        selectedSubOrg,
        mainAreaContext,
        loadingCloneActivity: state.loading.effects.lifeCycle.duplicateActivity && state.loading.models.lifeCycle,
        selectedAccount,
        setAccountName,
        accountData,
        accountLogoObjectCloudinary,
        isAllowedToAddOrgFlag,
        orgUniqueId: state.users.orgUniqueId,
        isDeleteDisabled,
        allAccounts,
        baseModuleType,
        packCount,
        intitiativeCountData,
        organizationCountData,
        contentCountData,
        accountSubscriptionDetail,
        isDefaultAccountSelected,
        PracticeLibrarys: state.lifeCycle.packArray,
        allList: state.lifeCycle.allList,
        InviteUserLoader: state.loading.effects.invite.sendInviteByAccountAsync,
        ImportPlayBookLoader:state.loading.effects.lifeCycle.importPlaybook,
        addedAccountUser: addedAccountUser,
        selectedCategory,
        userObj: state.users.userObj,
        activePageTab: state.lifeCycle.activePageTab,
        collapsedResourcePaneIndexTemp: state.app.collapsedResourcePaneIndexTemp,
        userRole: state.invite.userRole,
        inviteUserList: state.invite.inviteUserList,
        selectedActivityData: state.initiatives.selectedActivityData,
        selectedTag: state.account.selectedTag,
        teamsListViewFlag: state.app.teamsListViewFlag,
        showToolbarFlag,
        deActivateAccountModal,
        openViewAccountFlag: state.account.openViewAccountFlag,
        routeParams: state.app.routeParams,
        tableFilterQuery: state.app.tableFilterQuery,
        baseTableQuery: state.content.baseTableQuery,
        filterByStatus:state.lifeCycle.filterByStatus,
        contentListDataforCSV: state.content.contentListDataforCSV,
        selectedMultipleIds: state.content.selectedMultipleIds,
        selectedContent: state.content.selectedContent,
        contentListData: state.content.contentListData,
        selectedMultipleIds: state.content.selectedMultipleIds,
        loadingBulkPublish: state.loading.effects.content.publishedBulkContent && state.loading.models.content,
        loadingBulkDelete: state.loading.effects.content.deleteBulkContent && state.loading.models.content,
        loadingGetContentListData: state.loading.effects.content.getContentListData && state.loading.models.content,
        validPracticeName: state.lifeCycle.validPracticeName,
        categoryList: state.categories.categoryTreeList,
        decodedPlaybook: state.lifeCycle.decodedPlaybook,
        decodedContents: state.content.decodedContents,
        allCategoryList: state.categories.allCategoryList,
        allPlaybooksFromBaseId: state.lifeCycle.allPlaybooksFromBaseId,
        currentOrganization: state.organizationTab.currentOrganization,
        teamToExport: state.organizationUnit.teamToExport,
        resourcePaneFlag: state.content.resourcePaneFlag,
        playbook:state.lifeCycle.playbook,
        playbookGenerationState:state.lifeCycle.playbookGenerationState,
        playbookGenerationIndex:state.lifeCycle.playbookGenerationIndex,
        percentageGenerationComplete:state.lifeCycle.percentageGenerationComplete,
        generatedPlaybookName:state.lifeCycle.generatedPlaybookName,
        subscriptionLimitProps: state.app.subscriptionLimitProps,
        subscriptionLimitError: state.app.subscriptionLimitError,
        topUpCreditsProps: state.app.topUpCreditsProps,
        topUpCreditsModal: state.app.topUpCreditsModal,
        activeGenerationBlockedModal: state.app.activeGenerationBlockedModal,
        activeGenerationBlockedProps: state.app.activeGenerationBlockedProps,
    };
}

const connectedHomePage = withRouter(connect(mapStateToProps)(AppHeader));
export { connectedHomePage as AppHeader };


